<template>
   <ul class="f360-menu-editor h-menu h-menu-dark h-menu-mode-normal">
      <MenuItemDropDown label="Cards" icon="fas fa-columns">
        <span v-for="card in cards" :key="card.nomeOriginal">
         <MenuItem
          :label="card.nomeOriginal"
          :tipo="card.tipo"
          :reference="card.uiComponentName"
          :nomeOriginal="card.nomeOriginal"
          :associatedKPI="card.associatedKPI"
        />
        </span>

      </MenuItemDropDown>

      <MenuItemDropDown label="Gráficos" icon="fas fa-chart-line">
        <span v-for="chart in charts" :key="chart.nomeOriginal">
         <MenuItem
          :label="chart.nomeOriginal"
          :tipo="chart.tipo"
          :reference="chart.uiComponentName"
          :nomeOriginal="chart.nomeOriginal"
          :associatedKPI="chart.associatedKPI"
          :agrupamentosPossiveis="chart.agrupamentosPossiveis"
        />
        </span>
      </MenuItemDropDown>
        <MenuItemDropDown label="Rankings" icon="fa fa-trophy">
        <span v-for="table in tables" :key="table.nomeOriginal">
         <MenuItem
          :label="table.nomeOriginal"
          :tipo="table.tipo"
          :reference="table.uiComponentName"
          :nomeOriginal="table.nomeOriginal"
          :associatedKPI="table.associatedKPI"
          :agrupamentosPossiveis="table.agrupamentosPossiveis"
        />
        </span>
      </MenuItemDropDown>
       <MenuItemDropDown label="Painel" icon="fa fa-table">
        <span v-for="panel in panels" :key="panel.nomeOriginal">
         <MenuItem
          :label="panel.nomeOriginal"
          :tipo="panel.tipo"
          :reference="panel.uiComponentName"
          :nomeOriginal="panel.nomeOriginal"
          :associatedKPI="panel.associatedKPI"
          :agrupamentosPossiveis="panel.agrupamentosPossiveis"
        />
        </span>
      </MenuItemDropDown>
    </ul>
</template>

<script>
import MenuItem from './menuItem';
import MenuItemDropDown from './menuItemDropDown';
import {
  receitas,
  boletos,
  ticketMedio,
  valorMedioPorCupom,
  mediaItensPorCupom,
  boletoUm,
  evolucaoDeReceitas,
  evolucaoDeBoletos,
  qntMediaDeItensPorBoleto,
  valorMedioPorBoleto,
  taxaConversao,
  valorMedioPorItens
} from '../../js/config/dashboard-names';
import { Widgets } from '@/js/vuex/modules/dashboard/types';
export default {
  name: 'MenuModoEditor',
  components: {
    MenuItem,
    MenuItemDropDown
  },
  data: () => ({
    item: {},
    cards: [],
    charts: [],
    tables: [],
    panels: []
  }),
  mounted() {
    const [menu] = document.getElementsByClassName('h-layout-sider-theme-dark');

    this.item = menu;

    this.handleSideBarColor(true);

    R.DashBoardEditor.listarWidGets()
      .then(res => {
        const widgets = res.data.result;

        this.cards = widgets
          .filter(widget => widget.tipo === 'CARD');
        this.charts = widgets

          .filter(widget => widget.tipo === 'CHART');
        this.tables = widgets
          .filter(widget => widget.tipo === 'TABLE' && widget.uiComponentName !== 'PainelVendas');

        this.panels = widgets
          .filter(widget => widget.uiComponentName === 'PainelVendas');
      }).catch(err => {
        this.$Notice.error('Erro ao carregar a lista de widgets');
        console.log(err);
      });
  },
  methods: {
    handleSideBarColor(removerCor = true) {
      if (removerCor) {
        this.item.classList.remove('h-layout-sider-theme-dark');
      } else {
        this.item.classList.add('h-layout-sider-theme-dark');
      }
    }
  },
  computed: {
    receitas() {
      return receitas;
    },
    getEnumCard() {
      return Widgets.card;
    },
    getEnumGrafico() {
      return Widgets.chart;
    },
    boletos() {
      return boletos;
    },
    ticketMedio() {
      return ticketMedio;
    },
    valorMedioPorCupom() {
      return valorMedioPorCupom;
    },
    mediaItensPorCupom() {
      return mediaItensPorCupom;
    },
    boletoUm() {
      return boletoUm;
    },
    evolucaoDeReceitas() {
      return evolucaoDeReceitas;
    },
    evolucaoDeBoletos() {
      return evolucaoDeBoletos;
    },
    qntMediaDeItensPorBoleto() {
      return qntMediaDeItensPorBoleto;
    },
    valorMedioPorBoleto() {
      return valorMedioPorBoleto;
    },
    taxaConversao() {
      return taxaConversao;
    },
    valorMedioPorItens() {
      return valorMedioPorItens;
    }
  },
  beforeDestroy() {
    this.handleSideBarColor(false);
  }
};
</script>

<style lang="less">

@menu-prefix: ~"@{prefix}menu";
.f360-menu-editor {

  .h-layout-sider-theme-dark {
    background: #f4f5f7 !important;
  }

  background: #f4f5f7;

  .h-menu-show {
    color: #3c454f;
  }

  .h-menu-ul {
    background: #f4f5f7;
  }

  .h-menu-show:hover {
    background: #e2e2e2 !important;
  }

  .@{menu-prefix} {
    &-show {
      transition:0.2s;
      padding: 10px 15px;
      margin: 3px 9px;
      border-radius: 4px;
      font-size: 12px;
      &-icon {
        font-size: 14px;
      }
      &:hover {
        color: @primary-color;
        background: #e2e2e2;
      }
      &.h-menu-li-selected {
        color: @primary-color;
        background: #e2e2e2 !important;
      }
    }
    li.h-menu-li {
      color: #42526e;
    }
  }
  &.h-menu-size-collapse {
    .h-menu-show-desc {
      display:none;
    }
    li.h-menu-li li.h-menu-li {
      display:block;
    }
    span.h-menu-show-icon{
      i {
        font-size: 18px;
      }
    }
    .h-menu-show {
      padding-left: 12px;
    }
  }
}
.h-layout-sider-theme-white {
  background: #f4f5f7;
}
.scroll{
  overflow: scroll;
}
.h-menu {
  margin: -15px 0;
  padding-top: 12px;
}
.menu-header {
  height: 22px;
  background: #fff;
  border-bottom: 1px solid hsl(321, 69%, 40%);
  position: relative;
  line-height: 8px;
  z-index: 10;
  margin-bottom: 8px;
  padding: 0 13px;
  color: #9c9c9c;
  text-align: center;
}
</style>
